var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWallet(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1357_101990)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.3838 14.1753H1.61616C0.727273 14.1753 0 13.4214 0 12.4999V4.5753C0 3.65383 0.727273 2.8999 1.61616 2.8999H14.3838C15.2727 2.8999 16 3.65383 16 4.5753V12.4999C16 13.4214 15.2727 14.1753 14.3838 14.1753ZM1.61616 3.7376C1.21212 3.7376 0.808081 4.15645 0.808081 4.5753V12.4999C0.808081 13.0025 1.21212 13.3376 1.61616 13.3376H14.3838C14.8687 13.3376 15.1919 12.9188 15.1919 12.4999V4.5753C15.1919 4.07268 14.7879 3.7376 14.3838 3.7376H1.61616Z",
    fill: "#6D7781"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4343 5.2998H0V6.1375H15.4343V5.2998Z",
    fill: "#6D7781"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0323 9.2998H0V10.1375H10.0323V9.2998Z",
    fill: "#6D7781"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0323 10.8999H0.350159V11.7376H10.0323V10.8999Z",
    fill: "#6D7781"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1357_101990"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.1bea6585.svg";
export { ForwardRef as ReactComponent };